import React from "react";

const Familia = () => {
  return (
    <section className="familia-section d-flex align-items-start">
      <div className="familia-background" />
    </section>
  );
};

export default Familia;
